module.exports = __webpack_public_path__ + "static/media/telaviv.baeb60d5.jpg";